// apps/web/src/lib/decodeHtmlText.ts

/**
 * 서버에서 내려온 plain-text 필드(도서 소개 등)에 남아 있는
 * HTML 태그와 엔티티(&lt; &amp; &#39; ...)를 정리한다.
 *
 * 외부 도서 API(카카오/KOLIS/Dreamlab) 원문에 엔티티가 섞여 오고,
 * 24시간 검색 캐시에도 그대로 남아 있어서 렌더 직전 방어용으로 쓴다.
 * textarea.innerHTML 방식이라 스크립트는 실행되지 않고,
 * 숫자 엔티티(&#8216; 등)까지 브라우저가 알아서 디코드한다.
 */
export function decodeHtmlText(input?: string | null): string {
    if (!input) return "";

    let out = String(input)
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/p>/gi, "\n")
        .replace(/<[^>]+>/g, "");

    const ta = document.createElement("textarea");
    // 이중 인코딩(&amp;lt;)까지 풀되, 무한 디코딩은 막기 위해 최대 2회
    for (let i = 0; i < 2; i++) {
        ta.innerHTML = out;
        const next = ta.value;
        if (next === out) break;
        out = next;
    }

    return out
        .replace(/ /g, " ")
        .replace(/[ \t]+/g, " ")
        .trim();
}